import { fg } from '@atlassian/jira-feature-gating';

export default {
	get(): boolean {
		return fg('nike_dfo_use_haschildissues_field');
	},
};
